import React, { useState, useEffect } from 'react';

// Import your images
import heroBackgroundImg1 from '../../assets/images/stock-images/2.jpg';
import heroBackgroundImg2 from '../../assets/images/stock-images/3.jpg';
import heroImg5 from '../../assets/images/stock-images/6.jpg';
import heroImg6 from '../../assets/images/stock-images/1.jpg';
import heroImg8 from '../../assets/images/stock-images/8.jpg';

import { Link } from 'react-router-dom';
import Analytics from '../../utils/Analytics';
const HeroSection = () => {
	const getRandomIdx = (max) => {
		return Math.floor(Math.random() * max);
	};

	// Array of background images
	const heroImages = [
		heroBackgroundImg1,
		heroBackgroundImg2,
		heroImg5,
		heroImg6,
		heroImg8,
	];

	return (
		<div className='relative h-screen md:h-[1080px] overflow-hidden'>
			{/* overlay */}

			{/* Background image container */}
			<div className='absolute inset-0 animate-fade bg-none h-full w-full'>
				{heroImages.map((image, index) => (
					<div
						key={index}
						className='absolute inset-0 bg-cover bg-center opacity-20 animation-image'
						style={{
							backgroundImage: `url(${image})`,
							animationDelay: `${index * 5}s`,
						}}
					/>
				))}
			</div>

			<div className='absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center'>
				<div className='text-center text-white'>
					<h3 className='text-4xl md:text-lg font-semibold'>WELCOME TO</h3>
					<h1 className='text-6xl font-bold'>USA BLINDS</h1>
					<p className='mt-4 text-xl md:text-2xl'>
						Elevate your home with the best window treatments
					</p>
				</div>
				<div
					onClick={(e) => {
						e.preventDefault();
						document
							.getElementById('contact')
							?.scrollIntoView({ behavior: 'smooth' });

						if (window?.gtag) {
							window.gtag('event', 'click', {
								event_category: 'clickEvent:hero:GetAFreeEstimate',
								event_label: 'Get a Free Estimate Today',
							});
						}
						window.location.hash = '#contact';
					}}
				>
					<button
						id='menu-toggle'
						className='mt-8 px-6 py-3 bg-transparent border-4 text-white font-semibold text-lg rounded-sm hover:bg-primary-600 hover:text-white hover:border-primary-600 transition ease-in duration-300'
					>
						Get a Free Estimate Today
					</button>
				</div>
			</div>
		</div>
	);
};

export default HeroSection;
